// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"git-module--wrapper--3Wgnt","sendMessage":"git-module--sendMessage--J0l6a","slide":"git-module--slide--37Rmz"};